module.exports = __webpack_public_path__ + "penguin.jpg?57849f192c872621a5da0cca6a2bbd07";